import { useState, useEffect } from 'react';
import Footer from '../components/Footer.js';
import Preloader from "../components/Preloader.js"
import axios from 'axios';
import Users from '../components/Users.js';
import Notifications from '../components/Notifications.js';
import Campaigns from '../components/campaigns.js';
import MailingList from '../components/Mailing.js';
import Products from '../components/Products.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import Nav from '../components/Nav.js';

const Dashboard = () => {
    const base_url = process.env.REACT_APP_BASE_URL;
    const [loading, setLoading] = useState(false);
    // const [totalUsers, setTotalUsers] = useState(0)
    const [userActivity, setUserActivity] = useState(new Date());
    
    const api = axios.create({
        baseURL: `${base_url}`
    });

    // Set the authorization token for all requests
    api.interceptors.request.use((config) => {
        // Add your authorization token logic here
        const token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    // Add interceptor to log the user out on error
    api.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response.status === 401) {
                // Unauthorized error, log user out
                sessionStorage.removeItem('token');
                navigate("/login");
            }
            return Promise.reject(error);
        }
    );

    // Update user activity timestamp whenever there is any user interaction
    const updateUserActivity = () => {
        setUserActivity(new Date());
    };

    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000);

        // Listen for user interaction events
        window.addEventListener('mousemove', updateUserActivity);
        window.addEventListener('keydown', updateUserActivity);

        // Set up the inactivity timeout
        const inactivityTimeout = setInterval(() => {
            const currentTime = new Date();
            const elapsedTime = (currentTime - userActivity) / 1000; // Convert to seconds
            if (elapsedTime > 180) { // 3 minutes in seconds
                // User is inactive for 3 minutes, log them out
                sessionStorage.removeItem('token');
                navigate("/login");
            }
        }, 1000);


        // Cleanup event listeners and timeout when component unmounts
        return () => {
            window.removeEventListener('mousemove', updateUserActivity);
            window.removeEventListener('keydown', updateUserActivity);
            clearInterval(inactivityTimeout);
        };
    }, []);

    if (!sessionStorage.getItem('token')) {
        navigate("/login")
    } else {
        if (loading) {
            return (
                <Preloader />
            )
        } else {
            return (
                <>
                    <ToastContainer />
                    <div className="">
                        <Nav />
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12 mt-2">
                                    <div className="bg-white">
                                        <div className="col-xs-12 mb-4">
                                            <ul className="nav nav-pills nav-justified button-group mx-3">
                                                <li className="nav-item">
                                                    <a className="nav-link active" data-bs-toggle="pill" href="#users">Users</a>
                                                </li>
                                                {/* <li className="nav-item">
                                                    <a className="nav-link" data-bs-toggle="pill" href="#vacancy">Vacancy</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" data-bs-toggle="pill" href="#learning">Learning</a>
                                                </li> */}
                                                <li className="nav-item">
                                                    <a className="nav-link" data-bs-toggle="pill" href="#notifications">Notifications</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" data-bs-toggle="pill" href="#campaigns">Campaigns</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" data-bs-toggle="pill" href="#mailing">Mailing List</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" data-bs-toggle="pill" href="#products">Products</a>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="tab-content">
                                            <div className="tab-pane container-fluid active" id="users">
                                                <Users />
                                            </div>
                                            <div className="tab-pane container-fluid" id="notifications">
                                                <Notifications />
                                            </div>
                                            <div className="tab-pane container-fluid" id="campaigns">
                                                <Campaigns />
                                            </div>
                                            <div className="tab-pane container-fluid" id="mailing">
                                                <MailingList />
                                            </div>
                                            <div className="tab-pane container-fluid" id="products">
                                                <Products />
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )
        }
    }
}

export default Dashboard;
